import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const zonesApi = createApi({
  reducerPath: "zonesApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/" }),
  tagTypes: ["Zones"],
  endpoints: (builder) => ({
    getZones: builder.query({
      query: (metro) => ({
        url: "/zones",
        method: "GET",
        params: { metro },
      }),
      providesTags: ["Zones"],
    }),
  }),
});

export const { useGetZonesQuery } = zonesApi;
